import { GeneralStocksState } from '@/fsd/entities/remains/model/types/GeneralStocksStates';
import { FilterFieldOptions } from '@/fsd/shared/ui/filter-panel/types';

export const REMAINDERS_FILTER_OPTIONS: Array<FilterFieldOptions> = [
  {
    label: 'Положительные',
    value: GeneralStocksState.POSITIVE,
  },
  {
    label: 'Отрицательные',
    value: GeneralStocksState.NEGATIVE,
  },
  {
    label: 'Нулевые',
    value: GeneralStocksState.ZERO,
  },
];
